import { Box, Button } from '@mui/material'
import React from 'react'
import { connect } from 'react-redux'
import { DocumentFilePreview } from 'components/documents'
import { NivosModal } from 'components/index'
import {
  Operations as DocumentOperations,
  operations as documentOperations
} from 'states/dux/document/operations'
import { Payload as DocumentPayload } from 'states/dux/document/types'
import {
  Operations as LayoutOperations,
  operations as layoutOperations
} from 'states/dux/layout/operations'
import { Payload as LayoutPayload } from 'states/dux/layout/types'
import {
  Operations as ThemeOperations,
  operations as themeOperations
} from 'states/dux/theme/operations'
import { Payload as ThemePayload } from 'states/dux/theme/types'
import {
  Operations as UserAdminOperations,
  operations as userAdminOperations
} from 'states/dux/user-admin/operations'
import { Payload as UserAdminPayload } from 'states/dux/user-admin/types'
import {
  Operations as UserOperations,
  operations as userOperations
} from 'states/dux/user/operations'
import { Payload as UserPayload } from 'states/dux/user/types'
import State from 'states/types'
import { get, mapOperationsToDispatchProps } from 'utils/common'

interface StateProps {
  theme: ThemePayload
  layout: LayoutPayload
  user: UserPayload
  document_: DocumentPayload
  userAdmin: UserAdminPayload
}

interface DispatchProps {
  operations: {
    theme: ThemeOperations
    layout: LayoutOperations
    user: UserOperations
    document_: DocumentOperations
    userAdmin: UserAdminOperations
  }
}

type AppProps = StateProps & DispatchProps

const DocumentFileViewerFC: React.FC<any> = (props: AppProps) => {
  const { document_, operations } = props
  const [downLoading, setDownLoading] = React.useState(false)

  return (
    <NivosModal
      title={
        document_.selectedData !== undefined
          ? document_.selectedData.name
          : 'File Preview'
      }
      open={document_.selectedData !== undefined}
      setOpen={_ => operations.document_.setSelected(undefined)}
      containerProps={{
        sx: {
          height: 'fit-content',
          width: 'fit-content',
          padding: 3,
          borderRadius: 2
        }
      }}
    >
      {document_.selectedData !== undefined && (
        <Box
          display={'flex'}
          flexDirection={'column'}
          justifyContent={'center'}
          alignItems={'center'}
          height={800}
          width={800}
        >
          <DocumentFilePreview
            file={{ ...document_.selectedData }}
            containerProps={{ maxHeight: 800, maxWidth: 800 }}
          />
          <Box
            display={'flex'}
            alignItems={'center'}
            justifyContent={'space-evenly'}
            width={300}
            paddingY={2}
          >
            <Button
              variant={'contained'}
              disabled={downLoading}
              onClick={() => {
                if (document_.selectedData !== undefined) {
                  setDownLoading(true)
                  void get(
                    `/document/file/${
                      document_.selectedData.id as string
                    }/download/`,
                    false,
                    true
                  )
                    .then(response => response.blob())
                    .then((blob: Blob) => {
                      const url = window.URL.createObjectURL(new Blob([blob]))
                      const link = document.createElement('a')
                      const fileExtension: string =
                        document_.selectedData.fileName.split('.').slice(-1)[0]
                      link.href = url
                      link.setAttribute(
                        'download',
                        `${
                          document_.selectedData.name.trim() as string
                        }.${fileExtension.toLowerCase()}`
                      )
                      document.getElementById('root')?.appendChild(link)
                      link.click()
                      link.parentNode?.removeChild(link)
                      setDownLoading(false)
                      operations.document_.setSelected(undefined)
                    })
                }
              }}
            >
              {downLoading ? 'Downloading...' : 'Download'}
            </Button>
            <Button
              disabled={downLoading}
              variant={'outlined'}
              onClick={() => operations.document_.setSelected(undefined)}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      )}
    </NivosModal>
  )
}

const mapStateToProps = (state: State): StateProps => {
  return {
    theme: state.theme,
    layout: state.layout,
    user: state.user,
    document_: state.document,
    userAdmin: state.userAdmin
  }
}

const mapDispatchToProps = mapOperationsToDispatchProps({
  theme: themeOperations,
  layout: layoutOperations,
  user: userOperations,
  document_: documentOperations,
  userAdmin: userAdminOperations
})

const DocumentFileViewer = connect(
  mapStateToProps,
  mapDispatchToProps
)(DocumentFileViewerFC)

export default DocumentFileViewer
